import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Add this import
import AddIcon from "@mui/icons-material/Add";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import PropTypes from "prop-types";
import colors from "assets/theme/base/colors";

const HeaderCard = ({
    title,
    bgColor,
    showButton,
    buttonText,
    buttonBgColor,
    buttonTextColor,
    onButtonClick,
    showBackButton,
    onBackClick,
    buttonIcon,
}) => {
    return (
        <MDBox
            mx={2}
            mt={-3}
            py={showButton ? 1.6 : 2.3}
            px={2}
            variant="gradient"
            bgColor={bgColor || "primary"}
            borderRadius="lg"
            coloredShadow="primary"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
        >
            <MDBox display="flex" alignItems="center">
                {showBackButton && (
                    <MDButton
                        variant="text"
                        color="white"
                        size="large"
                        onClick={onBackClick}
                        mr={5}
                        style={{ minWidth: 0, minHeight: 0, padding: 5 }}
                    >
                        <ArrowBackIcon style={{ color: "white" }} />
                    </MDButton>
                )}
                <MDTypography variant="h6" color="white">
                    {title}
                </MDTypography>
            </MDBox>
            {showButton && (
                <MDButton
                    variant="contained"
                    startIcon={buttonIcon ?? <AddIcon />}
                    style={{
                        backgroundColor: buttonBgColor || "white",
                        color: buttonTextColor,
                    }}
                    onClick={onButtonClick}
                >
                    {buttonText}
                </MDButton>
            )}
        </MDBox>
    );
};

HeaderCard.propTypes = {
    title: PropTypes.string.isRequired,
    bgColor: PropTypes.string,
    showButton: PropTypes.bool,
    buttonText: PropTypes.string,
    buttonBgColor: PropTypes.string,
    buttonTextColor: PropTypes.string,
    onButtonClick: PropTypes.func,
    showBackButton: PropTypes.bool,
    onBackClick: PropTypes.func,
    buttonIcon: PropTypes.node,
};

HeaderCard.defaultProps = {
    bgColor: "primary",
    showButton: false,
    buttonText: "",
    buttonBgColor: "white",
    buttonTextColor: colors.primary.main,
    onButtonClick: () => { },
    showBackButton: false, // Default to not show
    onBackClick: () => { }, // Default empty function
    buttonIcon: null,
};

export default HeaderCard;
